import {
  Avatar,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  makeStyles,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { useHistory, useLocation } from "react-router";
import LongListEmailModal from "./LongList/LongListEmailModal";
import { Mail } from "@material-ui/icons";
import DataClient from "../../../../../../Service/general_data_service";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";
const dateFormatChanger = (scheduleDate) => {
  const dateSplit = scheduleDate.split("-");
  var d = parseInt(dateSplit[0], 10),
    m = parseInt(dateSplit[1], 10),
    y = parseInt(dateSplit[2], 10);
  const newDate = new Date(y, m - 1, d);
  console.log(newDate, "new date");
  const dateString = `${new Intl.DateTimeFormat("en-GB", {
    month: "short",
  }).format(newDate)} ${newDate.getDate()}, ${newDate.getFullYear()}`;
  return dateString;
};
const useStyles = makeStyles((theme) => ({
  small: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    margin: "0 auto",
  },
  bestMatched: {
    color: "#fff",
    backgroundColor: "#FF6565",
    padding: 5,
  },
  sessionInProgress: {
    color: "#fff",
    backgroundColor: "#4089FC",
    padding: 5,
  },
  sessionExpired: {
    width: "180px",
    height: "22px",
    textAlign: "center",

    borderRadius: 15,
    color: "#fff",
    backgroundColor: "#EF7000",
    padding: "8px 4px",
  },

  shortlistStatus: {
    width: "130px",
    height: "22px",
    textAlign: "center",
    borderRadius: 30,
    color: "#fff",
    backgroundColor: "green",
    padding: "8px 4px",
  },
}));

const mailsList = {
  shortlist: [
    {
      emailKey: "shortlist coach email",
      emailName: "Initial coach email",
      sendEmailKey: "shortlist coach email",
    },

    // { emailKey: "reminder for coach", emailName: "Reminder" },
    {
      emailKey: "unsuccessful selection for chemistry session",
      emailName: "Unsuccessful selection for chemistry",
      sendEmailKey: "unsuccessful selection for chemistry session",
    },
  ],
  chemistry: [
    {
      emailKey: "successful selection for chemistry",
      emailName: "Successful selection for chemistry",
      sendEmailKey: "successful selection for chemistry",
    },
    {
      emailKey: "unsuccessful selection from chemistry session",
      emailName: "Unsuccessful selection from chemistry",
      sendEmailKey: "unsuccessful selection from chemistry session",
    },
  ],
  confirmed: [
    {
      emailKey: "coach email",
      emailName: "Successful selection from chemistry",
      sendEmailKey: "confirmation email",
    },
  ],
};
const yesOrNoOptions = [
  { id: "Yes", value: "Yes" },
  { id: "No", value: "No" },
];
const UserCard = (props) => {
  const classes = useStyles();
  const {
    addFeedBackBtn,
    pageData,
    moved,
    buttonText,
    hideEmail,
    setPageUrl,
    content,
    getCoachList,
  } = props;
  const {
    session_scheduled,
    session_scheduled_date,
    include_shortlist_email,
    hogan_certified,
  } = pageData;
  const dispatch = useDispatch();
  const emailOptions = mailsList[content] || [];

  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [emailSelectedOption, setEmailSelectedOption] = useState(
    emailOptions[0]?.emailKey
  );
  const [includeShortlistEmail, setIncludeShortlistEmail] = useState(
    include_shortlist_email ? "Yes" : "No"
  );
  const [isHoganCertified, setIsHoganCertitified] = useState(
    hogan_certified ? "Yes" : "No"
  );
  const location = useLocation();

  const handleEmailChange = (event) => {
    setEmailSelectedOption(event.target.value);
  };
  const openEmailModal = () => {
    setIsEmailModalOpen(true);
  };
  const closeEmailModal = () => {
    setIsEmailModalOpen(false);
  };
  const handleIncludeChange = (pageData, include) => {
    const { coach_id } = pageData;
    const assignment_id = location?.state?.currentAssignment?.id;
    DataClient.create(
      {
        coach_id,
        assignment_id,
        include_shortlist_email: `${include === "Yes" ? true : false}`,
      },
      "shortlisting_coaches/include_into_client_shortlist"
    )
      .then((resp) => {
        if (resp.success) {
          getCoachList();
          dispatch(showSnackbar("success", [resp.message], 1000));
          setIncludeShortlistEmail(include);
        } else {
          dispatch(showSnackbar("error", [resp.message], 1000));
        }
      })
      .catch((err) => {
        dispatch(showSnackbar("error", ["something went wrong"], 1000));
      });
  };
  const handleHoganCertifiedChange = (pageData, certified) => {
    const assignment_id = location?.state?.currentAssignment?.id;
    DataClient.create(
      {
        assignment_id,
        hogan_certified: `${certified === "Yes" ? true : false}`,
      },
      "shortlisting_coaches/hogan_certified_yes_or_no"
    )
      .then((resp) => {
        if (resp.success) {
          getCoachList();
          dispatch(showSnackbar("success", ["Updated successfully"], 1000));
          setIsHoganCertitified(certified);
        } else {
          dispatch(showSnackbar("error", [resp.message], 1000));
        }
      })
      .catch((err) => {
        dispatch(showSnackbar("error", ["something went wrong"], 1000));
      });
  };
  return (
    <>
      <div>
        <Box style={{ borderColor: "#CACED5" }}>
          <Box p={2} borderBottom={1} style={{ borderColor: "#CACED5" }}>
            <Grid container direction="row" spacing={2}>
              <Grid
                item
                xs={2}
                style={{
                  marginLeft: "-40px",
                }}
              >
                <Box>
                  <Avatar
                    alt="Remy Sharp"
                    src={props.pageData?.coach_image}
                    className={classes.small}
                  />
                </Box>
              </Grid>
              <Grid item xs={content === "confirmed" ? 7 : 10}>
                <Box>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    alignItems="center"
                  >
                    <Grid item xs={9} md={10}>
                      <Typography variant="subtitle1">
                        <Box fontWeight="fontWeightBold">
                          {props.pageData?.coach_name}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={2}>
                      {props.pageData?.match_status != null && (
                        <Typography variant="h2">
                          <Box
                            textAlign="center"
                            borderRadius={20}
                            className={classes.bestMatched}
                          >
                            {props.pageData?.match_status}
                          </Box>
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="h2" style={{ color: "#43425D" }}>
                        {/* <Box>
                            Organization: {props.pageData?.organisation_name}
                          </Box> */}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              {content === "confirmed" ? (
                <Grid
                  item
                  xs={3}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <div style={{ width: "60%", textAlign: "right" }}>
                    <Typography
                      variant="subtitle2"
                      style={{ fontSize: "14px" }}
                    >
                      Hogan certified :
                    </Typography>
                  </div>
                  <div style={{ width: "40%" }}>
                    <Select
                      id="hogan_certified"
                      value={isHoganCertified}
                      defaultValue={isHoganCertified}
                      onChange={(event) => {
                        handleHoganCertifiedChange(
                          pageData,
                          event.target.value
                        );
                      }}
                      displayEmpty
                      variant="outlined"
                      fullWidth
                      style={{
                        height: "32px",
                        borderRadius: "5px",
                      }}
                      title="Select hogan certified"
                    >
                      {yesOrNoOptions.map((hoganCertifiedOption) => {
                        return (
                          <MenuItem value={hoganCertifiedOption.id}>
                            {hoganCertifiedOption.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                </Grid>
              ) : null}
            </Grid>
          </Box>
          <Box px={0} my={2}>
            <Grid
              container
              direction="row"
              style={{
                paddingTop: buttonText === "longlist" && "40px",
              }}
            >
              <Grid item xs={6}>
                <Grid container>
                  {!hideEmail ? (
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        // gap: "0.5rem",
                      }}
                    >
                      <Select
                        id="shortlistEmails"
                        value={emailSelectedOption}
                        onChange={handleEmailChange}
                        displayEmpty
                        variant="outlined"
                        style={{
                          width: "75%",
                          height: "32px",
                          borderRadius: "5px 0px 0px 5px",
                        }}
                      >
                        {emailOptions?.map((emailDetail) => {
                          return (
                            <MenuItem value={emailDetail.emailKey}>
                              {emailDetail.emailName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <Button
                        size="small"
                        variant="contained"
                        onClick={openEmailModal}
                        style={{
                          textTransform: "none",
                          backgroundColor: "#40bac6",
                          color: "#fff",
                          borderRadius: "0px 5px 5px 0px",
                        }}
                        startIcon={
                          <MailOutlineIcon color="#fff" fontSize="20px" />
                        }
                      >
                        Send
                      </Button>
                    </Grid>
                  ) : null}
                  <Grid
                    item
                    xs={2}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    {content === "shortlist" ? (
                      <Select
                        id="include_to_shortlist"
                        value={includeShortlistEmail}
                        defaultValue={includeShortlistEmail}
                        onChange={(event) => {
                          handleIncludeChange(pageData, event.target.value);
                        }}
                        displayEmpty
                        variant="outlined"
                        fullWidth
                        style={{
                          width: "85%",
                          height: "32px",
                          borderRadius: "5px",
                        }}
                        title="Include the coach to client shortlist email"
                      >
                        {yesOrNoOptions.map((includeOption) => {
                          return (
                            <MenuItem value={includeOption.id}>
                              {includeOption.value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    ) : null}
                  </Grid>
                  {addFeedBackBtn ? (
                    <Grid
                      item
                      xs={4}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        disableElevation
                        variant="contained"
                        color="secondary"
                        style={{
                          marginLeft: 10,
                          textTransform: "none",
                        }}
                        onClick={() => {
                          setPageUrl("Feedback");
                        }}
                      >
                        Add feedback
                      </Button>
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  textAlign: "-webkit-right",
                  display: "flex",
                  gap: "0.75rem",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* {addNotScheduledBtn ? <Typography variant="body1">
                  <Box
                    className={classes.sessionExpired}
                  >
                    Not scheduled
                  </Box>
                </Typography> : */}
                <Grid container>
                  {moved ? (
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        variant="h3"
                        className={classes.shortlistStatus}
                      >
                        {buttonText === "shortlist"
                          ? "Shortlisted"
                          : buttonText === "confirmed"
                          ? "Confirmed"
                          : "Chemistry"}
                      </Typography>
                    </Grid>
                  ) : null}

                  {session_scheduled === "Yes" ? (
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{
                          fontSize: "14px",
                          backgroundColor: "#E3EDFF",
                          borderRadius: "0.25rem",
                          color: "#478DFC",
                          padding: "0.2rem 0.75rem",
                        }}
                      >
                        Scheduled on {dateFormatChanger(session_scheduled_date)}
                      </Typography>
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </Box>
          {isEmailModalOpen && emailSelectedOption !== "" ? (
            <LongListEmailModal
              isOpen={isEmailModalOpen}
              onClose={closeEmailModal}
              {...props}
              contentType={emailSelectedOption}
              sendEmailContentType={
                emailOptions.find((el) => el.emailKey === emailSelectedOption)
                  .sendEmailKey || ""
              }
            />
          ) : null}
        </Box>
      </div>
    </>
  );
};

export default UserCard;
